import { Injectable } from '@angular/core';
import { MenuModel } from './model/menu.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) { }

  getMenuList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/menu/get', requestData);

  }

  getMenuDepartments(): Observable<any> {
    return this.http.post(environment.baseUrl+'/menu/menu-departments','');

  }

  getMenuById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/menu/get/'+id, '');

  }

   /**
   * 
   * @param reasonsInfo 
   * Calls the update API to insert/update the record
   */
   update(reasonsInfo: MenuModel): Observable<any> { 
    if(reasonsInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/menu/update', reasonsInfo);
    } else{
      return this.http.post(environment.baseUrl+'/menu/add', reasonsInfo);
    }
  }


    /**
   * 
   * @param menuInfo 
   * Calls the API to delete the record
   */
    delete(menuInfo: MenuModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/menu/delete/'+menuInfo.id, menuInfo);
    }

    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(environment.baseUrl + '/menu/export', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }

}
